import { SafeAreaView, ScrollView } from "react-native";
import { useCallback, useEffect, useState } from "react";
import { routeHome, routeMyLibrary, routeNewCuration } from "../../Routes";
import { useFocusEffect, useNavigation } from "@react-navigation/native";
import { getPlaylistSummary, getVamPlaylistSummary } from "../../services/apiMoviesContentService";
import { AppLogger } from "../../utils/AppLogger";
import { getItem, getTransactionFilters, globalAny, recordAnalytics, uniqueChannel } from "../../utils/Utils";
import { Categories, Pages } from "../../Types";
import { getCategories } from "../../services/categoriesService";
import AggregatePageLoader from "../../components/Loaders/AggregatePageLoader";
import TopAppBar from "../../components/TopAppBar";
import backIcon from "../../assets/TopNavBarIcon/icon_nav_back.svg";
import closeIcon from "../../assets/TopNavBarIcon/icon_nav_close.svg";
import CardGridPlaylist from "../../components/CardGridPlaylist";
import useGenericContentStore from "../../store/genericContent.store";
import GalleryContainer from "../../components/Layout/GalleryContainer";
import useToggleStore from "../../store/useToggle.store";
import ControllerContent from "../../components/ControllerContent";
import ScreenIcon from "../../assets/ControllerIcon/Screen-Icon.svg";
import useMqttStore from "../../store/useMqtt.store";
import { Props } from "./model";
import { StyledContainer, StyledGridPackshots, StyledControllerContainer, StyledControllerLoader, StyledLoaderFrame } from "./styled";
import useScreenDimensions from "../../hooks/useScreenDimensions";
import ControllerContainer from "../../components/Layout/ControllerContainer";
import ImgProgressBar from "../../components/Loaders/ImgProgressBar";
import { EventType } from "../../enums/EventType";

const myLibrary = Categories.myLibrary;
const studioTwo = Categories.studioTwo;
const pageSize = 30;

const AggregatePage = (props: Props) => {
	const { id, customListId, location } = props.route.params;
	const aggregateTitle = useGenericContentStore((state: any) => state.aggregateTitle);
	const [title, setTitle] = useState(aggregateTitle);
	const [playList, setPlayList] = useState<any>([]);
	const [vamList, setVamList] = useState<any>([]);
	const [searchLoader, setSearchLoader] = useState(false);
	const [gridSize, setGridSize] = useState<any>(id ? 6 : 4);
	const [currentPage, setCurrentPage] = useState(1);
	const [categoriesStore, setCategoriesStore] = useState([]);
	const [isReachLimit, setIsReachLimit] = useState(false);
	const setNavigateEvent = useGenericContentStore((state: any) => state.setNavigateEvent);
	const setAggregatePageId = useGenericContentStore((state: any) => state.setAggregatePageId);
	const isToggleMQTT = useToggleStore((state: any) => state.isToggleMQTT);
	const mqttDevices = useMqttStore((state: any) => state.mqttDevices);
	const navigation = useNavigation<any>();
	const controllerData = [
		{ id: 0, icon: ScreenIcon, buttonText: globalAny.language.assign_to_screens, textDescription: globalAny.language.assign_media_to_screen },
		{ id: 1, icon: "", buttonText: globalAny.language.cancel, textDescription: globalAny.language.select_media_to_assign },
	];
	const [controller, setController] = useState(controllerData[0]);
	const [channelData, setChannelData] = useState([]);
	const [vamId, setVamId] = useState(0);
	const isNarrow = useGenericContentStore((state: any) => state.isNarrow);
	const contentPerRow = isNarrow ? 20 : 24;
	const [next, setNext] = useState(contentPerRow);
	const { width } = useScreenDimensions();

	const onController = () => {
		if (vamId === 0) {
			setController(controllerData[1]);
			setVamId(1);
			return;
		}
		setController(controllerData[0]);
		setVamId(0);
	};

	const fetchData = async (pageSize?: number, nextPage?: number, categories?: any) => {
		return id
			? await getPlaylistSummary(location, getTransactionFilters(), pageSize, nextPage, categories, true)
			: await getVamPlaylistSummary(studioTwo, getTransactionFilters(), pageSize, nextPage, categories);
	};

	const filterData = (page: any) => {
		const filterCriteria = (item: any) => (id ? item.id === Number(id) : item.customListId === customListId);
		const isLandscape = !id && customListId;

		return page
			.filter((item: any) => filterCriteria(item))
			.map((val: any) => {
				return { ...val, isLandscape };
			});
	};

	const Init = async () => {
		try {
			const categories: any = (await getCategories(id ? location : studioTwo, getTransactionFilters())) ?? [];
			const filterByProductId = categories?.filter((cat: any) => cat.id === Number(id) || cat.customListId === customListId);

			setCategoriesStore(filterByProductId);
			const page = await fetchData(pageSize, currentPage, filterByProductId);
			const [data]: any = id ? getItem(filterData(page)) : filterData(page);
			if (id) {
				setPlayList(data);
				setTitle(aggregateTitle || data.title);
				return;
			}

			setVamList(data);
			setTitle(aggregateTitle || data.title);
		} catch (err) {
			AppLogger.log(err);
		}
	};

	useEffect(() => {
		if (!mqttDevices.length) {
			return;
		}

		const unique = uniqueChannel(mqttDevices);
		setChannelData(unique);
	}, [mqttDevices]);

	useEffect(() => {
		setController(controllerData[0]);
		Init();
		setAggregatePageId(id || customListId, location);
		setNavigateEvent(id ? Pages.homeAggregatePage : Pages.vamAggregatePage);
	}, []);

	/**
	 * useEffect to detect resize on window
	 */
	useEffect(() => {
		const resizeHandler = () => {
			setGridSize(calculateGridItemsByWindowWidth(width));
		};
		resizeHandler();

		window.addEventListener("resize", resizeHandler);
		return () => window.removeEventListener("resize", resizeHandler);
	}, [width]);

	useFocusEffect(
		useCallback(() => {
			if (title) recordAnalytics(EventType.ScreenView, { screen_name: Pages.page, page_id: id || customListId, page_title: title });
		}, [title]),
	);

	const calculateGridItemsByWindowWidth = (width: any) => {
		if (id) return onPortraitSize(width);
		return onLandscapeSize(width);
	};

	const onPortraitSize = (width: number) => {
		if (width <= 1659 && !isNarrow) return 4;
		if (width <= 1659 && isNarrow) return 10;
		return 6;
	};

	const onLandscapeSize = (width: number) => {
		if (width <= 619) return 3;
		if (isNarrow) return 5;
		return 4;
	};

	const onBackPress = () => {
		if (id) {
			navigation.navigate(location === myLibrary ? routeMyLibrary : routeHome);
		} else {
			navigation.navigate(routeNewCuration);
		}
		setNavigateEvent("");
	};

	const onClose = () => {
		setNavigateEvent("");
		navigation.navigate(routeHome);
	};

	const isCloseToBottom = ({ layoutMeasurement, contentOffset, contentSize }: any) => {
		const paddingBottom = 100;
		return layoutMeasurement.height + contentOffset.y >= contentSize.height - paddingBottom;
	};

	const onLazyLoading = async () => {
		AppLogger.log(`Next Page Count: ${next} Playlist Count: ${playList?.products?.length}`);

		if (next >= playList?.products?.length || next >= vamList?.products?.length) return;
		setSearchLoader(true);

		const nextPageNumber = currentPage + 1;
		setCurrentPage(nextPageNumber);

		try {
			if (isReachLimit) {
				setNext(next + gridSize);
				return;
			}

			const page = await fetchData(pageSize, nextPageNumber, categoriesStore);
			const [nextPageResults]: any = id ? getItem(filterData(page)) : filterData(page);
			setIsReachLimit(nextPageResults.products.length === 0);
			if (nextPageResults) {
				id
					? setPlayList({ ...playList, products: [...playList.products, ...nextPageResults.products] })
					: setPlayList({ ...vamList, products: [...vamList.products, ...nextPageResults.products] });
				setSearchLoader(false);
				setNext(next + gridSize);
			}
		} catch (err) {
			AppLogger.log(err);
		} finally {
			setSearchLoader(false);
		}
	};

	return (
		<SafeAreaView>
			{/* @ts-ignore */}
			<StyledContainer>
				<TopAppBar
					leftIcon={closeIcon}
					leftIconWidth={92}
					leftTitleIcon={backIcon}
					screenTitle={title}
					onPressLeftTitleIcon={onBackPress}
					onPressLeftIcon={onClose}
					isNarrow={isNarrow}
				/>
				<ScrollView>
					{isToggleMQTT && customListId && vamList.length !== 0 ? (
						//@ts-ignore
						<ControllerContainer isNarrow={isNarrow} isAggregate={true}>
							<ControllerContent
								data={controller}
								isTitle={channelData?.length <= 1}
								ribbonTitle={(globalAny as any).language.assign_single_screen_message}
								isShortClips={true}
								onPress={() => onController()}
								isNarrow={isNarrow}
							/>
						</ControllerContainer>
					) : (
						<></>
					)}

					{isToggleMQTT && customListId && vamList.length === 0 && isNarrow ? (
						//@ts-ignore
						<StyledControllerContainer>
							{/* @ts-ignore */}
							<StyledControllerLoader isLoading={true}>
								<ImgProgressBar isNoBorder />
							</StyledControllerLoader>
						</StyledControllerContainer>
					) : (
						<></>
					)}

					<GalleryContainer>
						<ScrollView
							onScroll={({ nativeEvent }) => {
								if (isCloseToBottom(nativeEvent) && !searchLoader && (vamList.products || playList.products)) {
									onLazyLoading();
								}
							}}
							scrollEventThrottle={400}
							style={{ paddingTop: 30, height: "100vh", width: isNarrow ? "100vw" : "" }}
						>
							{/* @ts-ignore */}
							<StyledGridPackshots isShortClips={!id} isNarrow={isNarrow}>
								{customListId && vamList.length === 0 && (
									<AggregatePageLoader load={contentPerRow} isVam={true} isNarrow={isNarrow} isToggleMQTT={isToggleMQTT} />
								)}
								{customListId && vamList.length !== 0 && (
									<CardGridPlaylist
										data={vamList.products.slice(0, next)}
										parentProductId={vamList.products[0].productId}
										isAggregate={true}
										isClips={true}
										isRedeem={true}
										isStudioAccess={true}
										isBorderClips={true}
										isAssignToScreen={vamId === 1}
										isToggleMQTT={isToggleMQTT}
									/>
								)}
								{id && playList?.length !== 0 ? (
									<CardGridPlaylist data={playList?.products.slice(0, next)} isAggregate={true} isToggleMQTT={isToggleMQTT} />
								) : (
									<></>
								)}
								{id && playList?.length === 0 && (
									<AggregatePageLoader load={contentPerRow} isVam={false} isNarrow={false} isToggleMQTT={isToggleMQTT} />
								)}
								{searchLoader && (
									<StyledLoaderFrame isToggleMQTT={isToggleMQTT} isNarrow={isNarrow} isVam={customListId}>
										<AggregatePageLoader load={contentPerRow} isVam={!id} slice={gridSize} isNarrow={isNarrow} />
									</StyledLoaderFrame>
								)}
							</StyledGridPackshots>
						</ScrollView>
					</GalleryContainer>
				</ScrollView>
			</StyledContainer>
			{isToggleMQTT && customListId && !isNarrow ? (
				<ControllerContent
					data={controller}
					isTitle={channelData?.length <= 1}
					ribbonTitle={globalAny.language.assign_single_screen_message}
					isShortClips={true}
					onPress={() => onController()}
				/>
			) : (
				<></>
			)}
		</SafeAreaView>
	);
};

export default AggregatePage;
